import React from 'react';
import { translate } from 'react-i18next';
import {Card, CardText} from 'material-ui/Card';
import OfferCreate from './OfferCreate';
import {List, ListItem} from 'material-ui/List';
import FlatButton from 'material-ui/FlatButton';
import { Link } from 'react-router-dom';
import user from '../Auth/user';
import firebase from '../firebase';
import compose from '../compose';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import LoadingIndicator from '../Navigation/LoadingIndicator';
import IconButton from 'material-ui/IconButton';
import Previous from 'material-ui/svg-icons/navigation/chevron-left';
import Next from 'material-ui/svg-icons/navigation/chevron-right';
import FirstPage from 'material-ui/svg-icons/navigation/first-page';
import LastPage from 'material-ui/svg-icons/navigation/last-page';

class OfferList extends React.Component {
  constructor(props) {
    super(props);
    this.initialState =  {
      offers: [],
      open: false,
      currentOffer: null,
      loadingIndicator: 'flex',
      offersPerPage: 25,
      isFirstPage: true,
      isLastPage: false
    };
    this.state = {
      ...this.initialState
    };
  }
  componentDidMount = () => {
    const {user} = this.props;

    if(user.shopkeeperId) {
      this.getFirstOffers(user.shopkeeperId);
    }
  }

  getFirstOffers = (shopkeeperId) => {
    this.props.firebase.database().ref(`shopkeepers/${shopkeeperId}/offers/`)
      .orderByChild('name')
      .limitToFirst(this.state.offersPerPage)
      .once('value', (queryOffers) => {
        this.updateFirstOffers(queryOffers);
        this.setState({loadingIndicator: 'none'});
      });
  }
  getLastOffers = () => {
    this.props.firebase.database().ref(`shopkeepers/${this.props.user.shopkeeperId}/offers/`)
      .orderByChild('name')
      .limitToLast(this.state.offersPerPage)
      .once('value', this.updateOffers);
    this.setState({isLastPage: true, isFirstPage: false});
  }
  getNextOffers = () => {
    this.props.firebase.database().ref(`shopkeepers/${this.props.user.shopkeeperId}/offers/`)
      .orderByChild('name')
      .limitToFirst(this.state.offersPerPage)
      .startAt(this.state.offers[this.state.offers.length - 1].name + 'a')
      .once('value', this.updateOffers);
    this.setState({isFirstPage: false});
  }
  getPreviousOffers = () => {
    this.props.firebase.database().ref(`shopkeepers/${this.props.user.shopkeeperId}/offers/`)
      .orderByChild('name')
      .limitToLast(this.state.offersPerPage)
      .endAt(this.state.offers[0].name.slice(0, -1))
      .once('value', this.updateOffers);
    this.setState({isLastPage: false});
  }

  updateFirstOffers = (queryOffers) => {
    const offers = [];
    queryOffers.forEach((data) => {
      const offer = {
        key: data.key,
        ...data.val()
      };
      offers.push(offer);
    });
    if (offers.length > 0) {
      this.setState({offers, firstOffer: offers[0].key, isFirstPage: true});
    } else {
      this.setState({isFirstPage: true, isLastPage: true});
      return;
    }

    this.props.firebase.database().ref(`shopkeepers/${this.props.user.shopkeeperId}/offers/`)
      .orderByChild('name')
      .limitToLast(1)
      .once('value', (offer) => {
        offer.forEach((lastOffer) => {
          const isLastPage = (offers[offers.length - 1].key === lastOffer.key);
          this.setState({isLastPage});
          this.setState({lastOffer: lastOffer.key});
        });
      });
  }

  updateOffers = (queryOffers) => {
    const offers = [];
    queryOffers.forEach((data) => {
      const offer = {
        key: data.key,
        ...data.val()
      };
      offers.push(offer);
    });
    this.setState({offers});
    if (offers[0].key === this.state.firstOffer) {
      this.setState({isFirstPage: true});
    }
    if (offers[offers.length - 1].key === this.state.lastOffer) {
      this.setState({isLastPage: true});
    }
  }

  handleOpen = () => {
    this.setState({open: true});
  }
  handleEdit = (offer) => {
    this.setState({open: true, currentOffer: offer});
  }
  handleClose = () => {
    this.setState({open: false, currentOffer: null});
  }
  render() {
    const {t} = this.props;
    const offers =
    this.state.offers.map((offer) => (
      <ListItem key={offer.key}
        primaryText={offer.name}
        secondaryText={offer.description}
        containerElement={<Link to={`/offers/${offer.key}`} />}
      />
    ));

    return (
      <Card className='cardStyle'>
        <Toolbar>
          <ToolbarGroup>
            <ToolbarTitle text={t('offer.offers')} />
          </ToolbarGroup>
          <ToolbarGroup lastChild={true}>
            <FlatButton label={t('offer.create')} primary={true} onTouchTap={this.handleOpen}/>
          </ToolbarGroup>
        </Toolbar>
        <CardText style={{textAlign: 'left', position: 'relative'}}>
          <List>
            {offers}
          </List>
          <div>
            <IconButton
              onTouchTap={() => this.getFirstOffers(this.props.user.shopkeeperId)}
              disabled={(this.state.isFirstPage)}>
              <FirstPage />
            </IconButton>
            <IconButton
              onTouchTap={this.getPreviousOffers}
              disabled={(this.state.isFirstPage)}>
              <Previous />
            </IconButton>
            <IconButton
              onTouchTap={this.getNextOffers}
              disabled={(this.state.isLastPage)}>
              <Next />
            </IconButton>
            <IconButton
              onTouchTap={this.getLastOffers}
              disabled={(this.state.isLastPage)}>
              <LastPage />
            </IconButton>
          </div>
          <LoadingIndicator display={this.state.loadingIndicator} />
          <OfferCreate handleClose={this.handleClose} open={this.state.open}/>
        </CardText>
      </Card>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(OfferList);



// WEBPACK FOOTER //
// ./src/Offer/OfferList.js